<template lang="pug">
    div
        lessonHeader
        lessonTitle
        v-layout(row justify-left)
            v-flex(text-xs-left)
                v-btn(v-if="!startPage" depressed class="white--text LifePlan-prevslide" @click.prevent="prevSlide")
                  font-awesome-icon(icon="arrow-left")
        v-layout(row justify-right)
            v-flex(text-xs-right)
                v-btn(v-if="!endPage || (isAddOther && slidestoAdvance < 0)" :disabled="!canAdvance" depressed class="white--text LifePlan-nextslide" @click.prevent="nextSlide")
                    font-awesome-icon(icon="arrow-right")            
        carousel.LifePlan-carousel(:perPage="1" @pageChange="pageChange" :mouseDrag="false" paginationColor='#1464A5' paginationActiveColor='#072146' ref="carousel")
            slide(v-for="(slide, slideIndex) in currentStep.slides", :key="slideIndex")
                v-layout(row)
                    v-flex(xl6 lg6 md6 sm6)
                        imageLoader(:imagesrc="slide.image")
                    v-flex.LifePlan-right.py-sm-1(xl6 lg6 md6 sm6)
                        component(:is="currentComponent" :slide="currentSlide"
                          @addProductAnswer="addProductAnswer"
                          @productTypeAnswer="productTypeAnswer"
                          @timeFrameAnswer="timeFrameAnswer"
                          @productNoteChange="productNoteChange"
                          @addOtherAnswer="addOtherAnswer")
        v-spacer.py-2
        buttonNext(:disabled="this.endPage === false || this.canAdvance === false")
        lessonFooter
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';
import imageLoader from "@/components/image-loader/image-loader";
import lessonTitle from '@/components/lesson-title/lesson-title';
import buttonNext from '@/components/button-next/button-next';
import lessonFooter from "@/components/lesson-footer/lesson-footer";
import lessonHeader from "@/components/lesson-header/lesson-header";

export default {
  name: 'LifePlan',
  components:{
	Carousel,
    Slide,
    imageLoader,
    lessonTitle,
    buttonNext,
    lessonFooter,
    lessonHeader
  },
  computed: {
    ...mapGetters(['currentStep']),
    isAddOther() {
      return ((this.currentSlide || {}).component || '').endsWith('add-other')
    }
  },
  methods: {
    ...mapActions(['nextStepSCORM']),
    nextSlide() {      
      for (let index = 0; index < this.slidestoAdvance * (this.slidestoAdvance > 0 ? 1: -1); index++) {
        this.$refs.carousel.advancePage((this.slidestoAdvance > 0 ? null: "backward"));        
      }      

      console.log(this.isAddOther)
      if (this.isAddOther && this.slidestoAdvance < 0) {
        this.addProductAnswer(true)
      }
      
      this.startPage = !this.$refs.carousel.canAdvanceBackward;
      this.endPage = !this.$refs.carousel.canAdvanceForward;      
    },
    prevSlide() {      
      this.$refs.carousel.advancePage("backward");
      this.startPage = !this.$refs.carousel.canAdvanceBackward;
      this.endPage = !this.$refs.carousel.canAdvanceForward;
    },    
    pageChange(page) {
        if(page === 0) {
            this.startPage = true;
            this.endPage = false;
        } else if (this.$refs.carousel.canAdvanceForward === false) {
            this.startPage = false;
            this.endPage = true;
        }
        this.currentSlide = this.currentStep.slides[page];
        this.canAdvance = this.currentSlide.canAdvance || false;
    },
    addProductAnswer(answer) {      
      this.canAdvance = true;
      if(answer) {        
        this.slidestoAdvance = 1;        
        this.product = { name: this.currentSlide.product, id: new Date().valueOf() };
      } else {
        this.slidestoAdvance = this.currentSlide.slidesToAdvance;        
        this.product = null;
        if (this.currentSlide.index === 6) {
          this.nextStepSCORM()
        }
      }      
    },
    productTypeAnswer (type) {
      this.canAdvance = true;      
      this.product.type = type.label;
    },
    timeFrameAnswer(timeframe) {
      this.product.timeframe = timeframe;
      const product = this.currentStep.data.products.find(p => p.id === this.product.id);
      if(product) {
        product.timeframe = timeframe;
      } else {
        this.currentStep.data.products.push(Object.assign({}, this.product));
      }
      this.canAdvance = true;
    },
    productNoteChange(note) {      
      const product = this.currentStep.data.products.find(p => p.id === this.product.id);
      if (product) {
        product.note = note;
      }
    },
    addOtherAnswer(addOther) {
      if(addOther) {
        this.slidestoAdvance = this.currentSlide.slidesToBack;
      } else {
        this.slidestoAdvance = 1;
      }
      this.canAdvance = true;
    }
  },
  mounted() {    
      this.currentSlide = this.currentStep.slides[0];
  },
  watch: {
    currentSlide: function (slide) {        
      this.currentComponent = () => import(`@/${slide.component}`);      
    },
    currentStep: function (step) {
      if(step.slides) {
        this.currentSlide = this.currentStep.slides[0];
      }      
    } 
  },
  data() {
        return {
            startPage: true,
            endPage: false,
            currentSlide: null,
            currentComponent: null,
            canAdvance: false,
            slidestoAdvance: 1,
            product: null
        }
    }
}
</script>

<style scoped>
    @import 'life-plan.scss';
</style>

